<script lang="ts">
	import { defineComponent } from "vue";
	import BannerCampus from "../components/landing/BannerCampusSlider.vue";
    import FormarBloqueLanding from "../components/landing/FormarBloqueLanding.vue";
    import Oferta from "../components/landing/Oferta.vue";
    import Ubicacion from "../components/landing/Ubicacion.vue";
    import Instalaciones from "../components/landing/Instalaciones.vue";
    import Tour360 from "../components/landing/Tour360.vue";
	// import ModelosEducativos from "../components/landing/ModelosEducativos.vue";
	// import OfertaEducativa from "../components/landing/OfertaEducativa.vue";
	// import HumanitasMuchoMas from "@/components/HumanitasMuchoMas.vue";


	export default defineComponent({
		name: "CampusPresaMadin",
		components: {
			BannerCampus,
            FormarBloqueLanding,
            Oferta,
            Ubicacion,
            Instalaciones,
            Tour360
		},
		props: {
			campus: {
				type: String,
				required: true,
			},
			banner: {
				type: String,
				required: true,
			},
        },
        data() {
            return {
                currentImage: 0,
                currentImage2: 0,
                images: [
                    '/pagesImages/instalaciones-Reyes-3.webp',
                    '/pagesImages/cancha-Reyes-2.webp',
                    '/pagesImages/salon-Reyes-1.webp',
                    '/pagesImages/biblioteca-Reyes-1.webp',
                    '/pagesImages/instalaciones-Reyes-2.webp',
                ],
                images2: [
                    '/pagesImages/instalaciones-Reyes-1.webp',
                    '/pagesImages/cancha-Reyes-1.webp',
                    '/pagesImages/cafeteria-Reyes-1.webp',
                    '/pagesImages/cancha-Reyes-3.webp',
                ],
                imagesArray: [
                    "/pagesImages/encabezado-landing-Reyes-1.webp",
                    "/pagesImages/encabezado-landing-Reyes-2.webp",
                ],
                altArray: [
                    "Fotos de campus Magno Los Reyes",
                    "Fotos de campus Magno Los Reyes",
                ],
                tour: [
                    { src:"/pagesImages/tour-Reyes-1.webp", title:"Tour virtual en Campus Magno Los Reyes"},
                    { src:"/pagesImages/tour-Reyes-3.webp", title:"Tour virtual en Campus Magno Los Reyes"},
                    { src:"/pagesImages/tour-Reyes-4.webp", title:"Tour virtual en Campus Magno Los Reyes"},
                    { src:"/pagesImages/tour-Reyes-5.webp", title:"Tour virtual en Campus Magno Los Reyes"},
                ],
                campusName: "LOS REYES",
                campusType: "CAMPUS MAGNO",
                localidad: "Estado de México",
                frase: "La curiosidad es la mecha de la vela del conocimiento",
                autor: "William Arthur Ward",
            }
        },
        methods: {
            nextImage() {
                this.currentImage = (this.currentImage + 1) % this.images.length
            },
            nextImage2() {
                this.currentImage2 = (this.currentImage2 + 1) % this.images2.length
            }
        }
	});
</script>

<template>
	<!-- <BannerCampus :banner="banner"/> -->
    <BannerCampus :campusType="campusType" :campus="campusName" :localidad="localidad" :slider="imagesArray" :alt="altArray" :frase="frase" :autor="autor" :banner="banner"/>
    <FormarBloqueLanding :frase="'Campus Los Reyes'" :testo1="'Combina excelencia académica con elegancia arquitectónica. Sus instalaciones están diseñadas para potenciar el aprendizaje, la innovación y el crecimiento integral.'" :testo2="'Las paredes cubiertas de vegetación, la fuente central con estilo renacentista y la armonía del paisaje crean un entorno que inspira serenidad, concentración y reflexión.'" :testo3="'Los programas académicos en este campus están alineados a las demandas del mercado, asegurando que cada egresado esté listo para sobresalir.'" :img="'/pagesImages/escultura-Reyes-1.webp'" :alt="'Campus Magno Los Reyes'" class="mb-16" />
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Instalaciones</h2>
            <p class="text-center mb-8">En la zona oriente de la Ciudad de México, este campus está diseñado<br class="lg:block hidden"> para formar a los profesionales que el mundo demanda.</p>
            <div class="flex flex-col justify-between">
                <div class="lg:flex items-center justify-center mb-16">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Auditorio Magno</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Diseñado para adaptarse a múltiples necesidades, en este espacio se realizan eventos culturales, conferencias, encuentros multidisciplinarios, foros, debates y presentaciones.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Instalaciones especializadas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Áreas equipadas para disciplinas como Psicología, Arquitectura, Diseño Gráfico y Derecho, con herramientas especializadas para el desarrollo práctico de los estudiantes.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Biblioteca y recursos digitales</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Con acceso a libros físicos, bases de datos digitales y computadoras, la biblioteca fomenta el estudio en un entorno cómodo y bien equipado.</p>
                        </div>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images[currentImage]"
                        alt="Instalaciones del Campus Magno Los Reyes"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                </div>
            </div>
            <div class="flex flex-col justify-between">
                <div class="lg:flex items-center justify-center">
                    <div class="flex items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images2[currentImage2]"
                        alt="Campus Magno Los Reyes"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage2"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                    <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Aulas interactivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Los salones cuentan con proyectores y sistemas de audio para clases dinámicas e interactivas.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Áreas verdes y deportivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Modernas instalaciones deportivas, como canchas de futbol rápido y baloncesto, equipadas con gradas.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Cafetería</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Despierta es un concepto de cafeterías que fusiona una alimentación saludable con el sabor casero de una comida nutritiva.</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="grid lg:grid-cols-2 grid-cols-1 gap-10">
                
            </div> -->
        </div>
    </div>
    <h2 class="text-hgold text-center font-serif md:text-[42px] text-[32px] lg:px-0 px-8 lg:mb-4 leading-none w-full">Oferta académica en<br class="lg:block hidden"> Campus Magno Los Reyes</h2>
    <Oferta :virtual=false :visibleOffers="{
        Licenciaturas: ['Administración', 'Contabilidad', 'Psicología' , 'Derecho', 'Arquitectura', 'Diseño Gráfico' ],
        Maestrías: ['Alta Dirección', 'Derecho Corporativo', 'Derecho Fiscal', 'Derecho Penal', 'Psicoterapia con un<br> enfoque Psicoanalítico', 'Contabilidad', 'Educación', ],
    }" class="flex items-center justify-center" />
    <section class="flex w-full items-center justify-center text-gray-700 mt-10">
        <div class="flex flex-col w-full max-w-[1200px] justify-center items-center">
            <div class="flex flex-col md:flex-row items-center justify-center mb-16 w-full max-w-4xl lg:max-w-[1200px]">
                <div class="order-2 md:order-1 flex w-full md:w-1/2 justify-center md:justify-end lg:px-0 px-8">
                    <img src="/pagesImages/landing-virtual-doctorado.webp" width="494" height="494" loading="lazy" class="w-auto h-auto" alt="Explora los diplomados">
                </div>
                <div class="order-1 md:order-2 flex flex-col lg:px-14 px-8 md:py-0 w-full md:w-1/2 items-center md:items-start">
                    <p class="text-center md:text-left line-height-36 text-4xl text-hgold mb-4 font-serif">Diplomados</p>
                    <ul class="text-left pl-6 space-y-1 list-disc">
                        <li class="">
                            <a href="https://humanitas.edu.mx/educacion-continua">Criminología</a>
                        </li>
                        <li class="">
                            <a href="https://humanitas.edu.mx/educacion-continua">Tanatología</a>
                        </li>
                    </ul>
                    <br>
                </div>
            </div>
        </div>
    </section>
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-16 leading-none w-full">Nuestros modelos educativos</h2>
            <section class="flex items-center justify-center mb-16 w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                                <h3>
                                    <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                    <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo ejecutivo</span>
                                </h3>
                                <p class=" lg:hyphens-none hyphens-auto">
                                    Está diseñado para brindar flexibilidad sin comprometer la calidad académica. Los programas se estructuran en bloques trimestrales, cada uno fusionando tres materias, impartidas por especialistas. Requiere autodisciplina, gestión eficiente del tiempo y compromiso con el éxito académico.
                                </p>
                            </div>
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/mujer-modelo-ejecutivo-universidad-humanitas.webp" alt="Modelo ejecutivo en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="flex items-center justify-center w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/modelo-escolarizado-madin.webp" alt="Estudiante modelo escolarizado en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
                            </div>
                            <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                                <h3>
                                    <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                    <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo escolarizado</span>
                                </h3>
                                <p class=" lg:hyphens-none hyphens-auto">
                                    Ofrece una formación académica de calidad con un enfoque práctico y humano. Cada licenciatura está diseñada con objetividad e integrada con talleres y seminarios, que potencian la preparación para enfrentar los desafíos del mundo actual con conocimiento, habilidades y experiencia.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Tour virtual</h2>
            <p class="mb-10">Conoce el Campus Magno Los Reyes en nuestro tour virtual.</p>
            <Tour360 :src="'https://tourmkr.com/F1wco0QzVQ/47007162p&341.19h&89.82t'"  class="w-full mb-12"/>
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-10 leading-none w-full">Galería</h2>
            <Instalaciones :items="tour" class="mb-8 " />
            <div class="mx-auto max-w-[1200px] aspect-video w-full">
                <iframe src="https://www.youtube.com/embed/ltQIhuPEPZw?si=3ed4AAPht6Rg0T_Z" title="Campus Magno Los Reyes" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen class="w-full h-full"></iframe>
            </div>
        </div>
    </div>
	<Ubicacion :campus="'Campus Magno Los Reyes'" :mapa="'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3764.2775557266455!2d-98.98493!3d19.357131!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1e29a201a3ab3%3A0x25fb001dbc7fc784!2sUniversidad%20Humanitas%20Campus%20Los%20Reyes!5e0!3m2!1ses-419!2sus!4v1691522279800!5m2!1ses-419!2sus'" :testo1="'El Campus está ubicado al oriente de la Ciudad de México, se puede llegar tanto en transporte público como en automóvil.'" :testo2="'Las siguientes líneas de transporte tienen rutas que pasan cerca de Campus Los Reyes. Autobús: 107,  112, 13,  2, Peñon- Metro Santa Martha. Metro línea A. Teleférico: L2.'" :testo3="'En auto, la vía de acceso es por el Av. Ignacio Zaragoza y Calzada Ermita.'" :ubicacion="'KM. 17.5 Carr. Libre México-Puebla 51<br>Esquina Mejoramiento Ambiental, Los Reyes Acaquilpan, La Paz.'" :telefono="'55-5858-6600'" class="lg:px-0 px-8" />
</template>

<style scoped>
</style>
